// Chakra imports
import {
    Box,
    Button,
    Flex,
    Grid, Input, Select, Switch,

} from "@chakra-ui/react";
import React, {useState} from "react";
import SalesOverview from "../components/SalesOverview";
import RateChart from "../components/Dashboard/RateChart";
import {useNavigate} from "react-router-dom";


export default function RateShedule() {
    const [selected, setSelected] = useState(true)
    const navigate = useNavigate();

    const toggle = () => {
        setSelected(!selected)
    }

    return (
        <Flex flexDirection='column' pt={{ base: "120px", md: "75px" }}>
            <Box w='100%' mb='20px'>
                <Flex maxW='500px'>
                    <Button colorScheme='teal' type='submit' onClick={() => {navigate(`/admin_area/rates`)}}>
                        Назад
                    </Button>
                </Flex>
            </Box>
            <label>Провайдер</label>
            <Box
                maxW='500px'
                w='100%'
                p={4}
            >
                <label htmlFor="normal-switch">
                    <Switch
                        id="normal-switch"
                        colorScheme='teal'
                        onChange={toggle}
                        checked={selected}
                        className="react-switch"
                    />
                    <span> {selected ? ' ' : ' input'}</span>
                </label>
                {selected
                    ? <Select
                        id='fx_provider'
                    >
                        <option value='mtsbank'>mtsbank</option>
                        <option value='superprovider'>superprovider</option>
                    </Select>
                    : <Input
                        autoFocus={true}
                        id='fx_provider'
                        placeholder='mtsbank'
                    />
                }

                <Button mt={4} colorScheme='teal'>
                    Отобразить
                </Button>

            </Box>

            <Grid
                templateColumns={{ sm: "1fr", lg: "1fr" }}
                templateRows={{ sm: "repeat(1, 1fr)", lg: "1fr" }}
                maxW={'100%'}
                maxH={'100%'}
            >
                <SalesOverview
                    title={"График курса"}
                    chart={<RateChart getAction={true}/>}
                />

            </Grid>
        </Flex>
    );
}
